import { TEMPLATE_TYPES } from 'cpool-constants';
import { divisionId } from 'cpool-schemas';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_DivisionFooterCreated extends _Event {
    constructor(payload: EventSchema<Template_DivisionFooterCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        // empty content allowed: blank fields fall back to the standard header/footer
        return z.object({
            divisionId,
            mailContent: z.string(),
            mailHTMLContent: z.string(),
            type: z.literal(TEMPLATE_TYPES.DIVISION_FOOTER),
        });
    }

    static example(): EventSchema<Template_DivisionFooterCreated> {
        return {
            divisionId: 'A1B2C3',
            mailContent: '',
            mailHTMLContent: '',
            type: TEMPLATE_TYPES.DIVISION_FOOTER,
        };
    }
}

export type Schema_Template_DivisionFooterCreated = EventSchema<Template_DivisionFooterCreated>;
